function initPlProductVideos(root = document) {
  const galleries = root.querySelectorAll('media-gallery, .product__media-wrapper, .product');
  if (!galleries.length) return;

  galleries.forEach((gallery) => {
    if (gallery.dataset.plVideoFixBound === 'true') return;
    gallery.dataset.plVideoFixBound = 'true';

    const getAllVideos = () => gallery.querySelectorAll('video');

    const getActiveMediaItems = () => {
      const active = gallery.querySelectorAll(
        '.product__media-item.is-active, .slider__slide.is-active, .thumbnail[aria-current="true"], .product__media-item[aria-current="true"]'
      );
      return active.length ? active : [];
    };

    const setupVideo = (video) => {
      video.muted = true;
      video.loop = true;
      video.autoplay = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('loop', '');
      video.setAttribute('autoplay', '');
      video.setAttribute('playsinline', '');
      video.preload = 'auto';
    };

    const playActiveVideos = () => {
      const videos = getAllVideos();
      if (!videos.length) return;

      videos.forEach((video) => {
        setupVideo(video);
      });

      const activeItems = getActiveMediaItems();

      if (activeItems.length) {
        videos.forEach((video) => {
          const parentMedia = video.closest('.product__media-item, .slider__slide, .thumbnail');
          const isActive = parentMedia && [...activeItems].includes(parentMedia);

          if (isActive) {
            const playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(() => {});
            }
          } else {
            video.pause();
          }
        });
      } else {
        videos.forEach((video) => {
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        });
      }
    };

    playActiveVideos();

    gallery.addEventListener('click', (event) => {
      if (
        event.target.closest('.thumbnail, .slider-button, [data-target], [data-media-id], button')
      ) {
        setTimeout(playActiveVideos, 120);
        setTimeout(playActiveVideos, 300);
      }
    });

    gallery.addEventListener('change', () => {
      setTimeout(playActiveVideos, 120);
      setTimeout(playActiveVideos, 300);
    });

    const observer = new MutationObserver(() => {
      setTimeout(playActiveVideos, 80);
    });

    observer.observe(gallery, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'aria-current', 'style']
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initPlProductVideos(document);
});

document.addEventListener('shopify:section:load', (event) => {
  initPlProductVideos(event.target);
});